import { createAction } from 'redux-act';
//

export const setUsedQuestionIds = createAction('setUsedQuestionIds');
export const appendToUsedQuestionIds = createAction('appendToUsedQuestionIds');
export const removeFromUsedQuestionIds = createAction('removeFromUsedQuestionIds');
